// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.19 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.visible {
  visibility: visible;
}
.collapse {
  visibility: collapse;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.mb-4 {
  margin-bottom: 1rem;
}
.ml-64 {
  margin-left: 16rem;
}
.\\!block {
  display: block !important;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.h-screen {
  height: 100vh;
}
.min-h-0 {
  min-height: 0px;
}
.min-h-screen {
  min-height: 100vh;
}
.w-64 {
  width: 16rem;
}
.w-full {
  width: 100%;
}
.flex-1 {
  flex: 1 1;
}
.shrink {
  flex-shrink: 1;
}
.border-collapse {
  border-collapse: collapse;
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.resize {
  resize: both;
}
.flex-col {
  flex-direction: column;
}
.items-center {
  align-items: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-3 {
  gap: 0.75rem;
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.overflow-y-auto {
  overflow-y: auto;
}
.break-all {
  word-break: break-all;
}
.rounded {
  border-radius: 0.25rem;
}
.border {
  border-width: 1px;
}
.p-4 {
  padding: 1rem;
}
.pr-1 {
  padding-right: 0.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.font-semibold {
  font-weight: 600;
}
.tabular-nums {
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.underline {
  text-decoration-line: underline;
}
.outline {
  outline-style: solid;
}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

/* ---------------------- Design tokens ---------------------- */
:root {
  --color-bg: #f4f5f9;
  --color-surface: #ffffff;
  --color-border: #e5e7eb;
  --color-border-strong: #d7dae1;
  --color-text: #14161f;
  --color-text-muted: #6b7280;
  --color-text-faint: #9ca3af;

  --color-primary: #4f46e5;
  --color-primary-hover: #4338ca;
  --color-primary-soft: #eef2ff;
  --color-primary-soft-text: #4338ca;

  --color-success: #059669;
  --color-success-soft: #ecfdf5;
  --color-danger: #dc2626;
  --color-danger-soft: #fef2f2;
  --color-warning: #d97706;
  --color-warning-soft: #fffbeb;
  --color-neutral-soft: #f1f2f6;
  --color-neutral-text: #4b5563;

  --radius-sm: 8px;
  --radius-md: 12px;
  --radius-lg: 16px;

  --shadow-xs: 0 1px 2px rgba(16, 24, 40, 0.05);
  --shadow-sm: 0 1px 3px rgba(16, 24, 40, 0.08), 0 1px 2px rgba(16, 24, 40, 0.04);
  --shadow-md: 0 8px 24px rgba(16, 24, 40, 0.08);
  --shadow-lg: 0 24px 60px rgba(16, 24, 40, 0.18);
}

/* ---------------------- Base Styles ---------------------- */
* {
  box-sizing: border-box;
}

body {
  overflow-x: hidden;
  margin: 0;
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  background: var(--color-bg);
  color: var(--color-text);
  -webkit-font-smoothing: antialiased;
}

/* ---------------------- Login Page ---------------------- */
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background:
    radial-gradient(600px circle at 15% 20%, rgba(79, 70, 229, 0.10), transparent 60%),
    radial-gradient(600px circle at 85% 80%, rgba(79, 70, 229, 0.08), transparent 60%),
    var(--color-bg);
}

.login-form {
  background: var(--color-surface);
  padding: 40px 36px;
  border-radius: var(--radius-lg);
  border: 1px solid var(--color-border);
  box-shadow: var(--shadow-md);
  text-align: center;
}

.login-form h2 {
  margin: 0 0 6px;
  font-size: 22px;
  font-weight: 800;
  color: var(--color-text);
  letter-spacing: -0.01em;
}

.login-form .login-subtitle {
  color: var(--color-text-muted);
  font-size: 13.5px;
  margin-bottom: 24px;
}

.login-form input {
  width: 100%;
  padding: 12px 14px;
  margin: 8px 0;
  border: 1px solid var(--color-border-strong);
  border-radius: var(--radius-sm);
  font-size: 14px;
  font-family: inherit;
  background: #fbfbfd;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
}

.login-form input:focus {
  outline: none;
  border-color: var(--color-primary);
  background: var(--color-surface);
  box-shadow: 0 0 0 3px var(--color-primary-soft);
}

/* ---------------------- Buttons ---------------------- */
button {
  font-family: inherit;
}

button.primary,
.primary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  background-color: var(--color-primary);
  color: #fff;
  border: 1px solid var(--color-primary);
  padding: 9px 16px;
  border-radius: var(--radius-sm);
  cursor: pointer;
  font-weight: 600;
  font-size: 13.5px;
  transition: background 0.15s ease, box-shadow 0.15s ease, transform 0.05s ease;
  box-shadow: var(--shadow-xs);
}

button.primary:hover,
.primary:hover {
  background-color: var(--color-primary-hover);
  border-color: var(--color-primary-hover);
}

button.primary:active,
.primary:active {
  transform: translateY(1px);
}

button.primary:disabled,
.primary:disabled {
  background-color: #c7c9f5;
  border-color: #c7c9f5;
  cursor: not-allowed;
  box-shadow: none;
}

.secondary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: auto;
  padding: 9px 16px;
  background-color: var(--color-surface);
  color: var(--color-text);
  border: 1px solid var(--color-border-strong);
  border-radius: var(--radius-sm);
  cursor: pointer;
  font-weight: 600;
  font-size: 13.5px;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.secondary:hover {
  background-color: #f9fafb;
  border-color: #c6c9d2;
}

.secondary:disabled {
  color: var(--color-text-faint);
  cursor: not-allowed;
}

button.close-btn {
  background-color: var(--color-surface);
  color: var(--color-text-muted);
  border: 1px solid var(--color-border-strong);
  padding: 6px 14px;
  border-radius: var(--radius-sm);
  cursor: pointer;
  font-weight: 600;
  font-size: 13px;
  transition: background 0.15s ease, color 0.15s ease;
}

button.close-btn:hover {
  background-color: var(--color-danger-soft);
  color: var(--color-danger);
  border-color: #f3c6c6;
}

.logout {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background-color: var(--color-surface);
  color: var(--color-danger);
  border: 1px solid var(--color-border-strong);
  padding: 8px 14px;
  border-radius: var(--radius-sm);
  cursor: pointer;
  font-weight: 600;
  font-size: 13.5px;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.logout:hover {
  background-color: var(--color-danger-soft);
  border-color: #f3c6c6;
}

/* ---------------------- Loading Spinner ---------------------- */
.loading-overlay {
  position: absolute;
  inset: 0;
  z-index: 50;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(244, 245, 249, 0.72);
  backdrop-filter: blur(4px);
  border-radius: var(--radius-lg);
}

.spinner-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 18px 24px;
  border-radius: var(--radius-lg);
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  box-shadow: var(--shadow-md);
  min-width: 180px;
}

.spinner-ring {
  width: 36px;
  height: 36px;
  border-radius: 999px;
  border: 3px solid var(--color-primary-soft);
  border-top-color: var(--color-primary);
  animation: spinner-rotate 0.8s linear infinite;
}

.spinner-ring-sm {
  width: 16px;
  height: 16px;
  border-width: 2px;
}

.spinner-label {
  font-size: 13.5px;
  font-weight: 600;
  color: var(--color-text);
  text-align: center;
}

@keyframes spinner-rotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* ---------------------- Page shell ---------------------- */
.page-panel {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-xs);
  padding: 20px 22px;
  position: relative;
}

/* ---------------------- Tables ---------------------- */
.table-wrapper {
  overflow-x: auto;
  border-radius: var(--radius-md);
  border: 1px solid var(--color-border);
  margin-top: 16px;
}

table {
  width: 100%;
  border-collapse: collapse;
  background-color: var(--color-surface);
  border-radius: var(--radius-md);
}

th, td {
  padding: 12px 16px;
  text-align: left;
  border: none;
  border-bottom: 1px solid var(--color-border);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 13.5px;
  max-width: 240px;
}

thead th {
  position: sticky;
  top: 0;
  background-color: #fafafc;
  font-weight: 600;
  font-size: 11.5px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--color-text-muted);
  z-index: 1;
  border-bottom: 1px solid var(--color-border);
}

tbody tr {
  transition: background 0.1s ease;
}

tbody tr:last-child td {
  border-bottom: none;
}

tbody tr:hover {
  background-color: #fafafd;
}

td {
  color: var(--color-text);
}

.success { color: var(--color-success); }
.error { color: var(--color-danger); }

/* ---------------------- Status badges ---------------------- */
.badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 11.5px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  white-space: nowrap;
}
.badge::before {
  content: "";
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: currentColor;
}
.badge-gray { background: var(--color-neutral-soft); color: var(--color-neutral-text); }
.badge-blue { background: var(--color-primary-soft); color: var(--color-primary-soft-text); }
.badge-green { background: var(--color-success-soft); color: var(--color-success); }
.badge-red { background: var(--color-danger-soft); color: var(--color-danger); }
.badge-amber { background: var(--color-warning-soft); color: var(--color-warning); }

/* ---------------------- Dropdowns / toolbar inputs ---------------------- */
.dropdowns {
  margin: 10px 0 20px;
}

.action-buttons {
  white-space: nowrap;
  /* cells are capped at 240px with hidden overflow; a row of action buttons must never be clipped */
  max-width: none;
  overflow: visible;
}

/* td.flex would stop the cell behaving like a table cell, so the buttons are laid out inline with a gap instead */
td.action-buttons.flex {
  display: table-cell;
}

.action-buttons button {
  font-size: 12.5px;
  padding: 7px 13px;
  margin-right: 6px;
  color: var(--color-primary-soft-text);
  border-color: var(--color-primary);
  background-color: var(--color-primary-soft);
}

.action-buttons button:last-child {
  margin-right: 0;
}

.action-buttons button:hover {
  background-color: var(--color-primary);
  color: #fff;
}

/* Wide tables: keep the Actions column in view while the rest scrolls sideways */
th.sticky-actions,
td.sticky-actions {
  position: sticky;
  right: 0;
  z-index: 2;
  box-shadow: -8px 0 8px -8px rgba(15, 17, 26, 0.18);
}

td.sticky-actions {
  background-color: var(--color-surface);
}

tbody tr:hover td.sticky-actions {
  background-color: #fafafd;
}

/* ---------------------- Modal ---------------------- */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(15, 17, 26, 0.5);
  backdrop-filter: blur(2px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  padding: 20px;
}

.modal-box {
  background: var(--color-surface);
  padding: 28px 30px;
  border-radius: var(--radius-lg);
  width: 90%;
  max-width: 760px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: var(--shadow-lg);
  border: 1px solid var(--color-border);
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px 20px;
  margin-top: 16px;
}

@media (max-width: 600px) {
  .form-grid {
    grid-template-columns: 1fr;
  }
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group label {
  font-size: 12.5px;
  color: var(--color-text-muted);
  font-weight: 600;
  margin-bottom: 6px;
}

.form-group input,
.form-group select {
  padding: 9px 12px;
  font-size: 13.5px;
  font-family: inherit;
  border-radius: var(--radius-sm);
  border: 1px solid var(--color-border-strong);
  background-color: #fbfbfd;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
}

.form-group input:focus,
.form-group select:focus {
  border-color: var(--color-primary);
  outline: none;
  background: var(--color-surface);
  box-shadow: 0 0 0 3px var(--color-primary-soft);
}

/* Item rows of the invoice / order forms: the boxes are typed into directly in the table, so they need a visible outline */
.items-table td {
  vertical-align: middle;
}

.items-table input:not([tabindex="-1"]),
.items-table select {
  padding: 7px 10px;
  min-width: 0;
  font-size: 13.5px;
  font-family: inherit;
  color: var(--color-text);
  border-radius: var(--radius-sm);
  border: 1px solid #aab1bf;
  background-color: var(--color-surface);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.items-table select {
  width: 100%;
  min-width: 200px;
}

.items-table input:not([tabindex="-1"]):focus,
.items-table select:focus {
  border-color: var(--color-primary);
  outline: none;
  box-shadow: 0 0 0 3px var(--color-primary-soft);
}

.items-table input::placeholder {
  color: var(--color-text-faint);
}

.items-table button[type="button"]:not(.close-btn) {
  border-color: #aab1bf !important;
}

.field-error {
  color: var(--color-danger);
  font-size: 11px;
  margin-top: 4px;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 24px;
  padding-top: 18px;
  border-top: 1px solid var(--color-border);
}

/* Toolbar / filters */
.filters-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 4px;
}

.filters-bar select,
.filters-bar input[type="text"],
.filters-bar input[type="date"] {
  padding: 9px 12px;
  font-size: 13.5px;
  font-family: inherit;
  border: 1px solid var(--color-border-strong);
  border-radius: var(--radius-sm);
  background-color: var(--color-surface);
  min-width: 150px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.filters-bar select:focus,
.filters-bar input:focus {
  outline: none;
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px var(--color-primary-soft);
}

.filters-bar input[type="text"] {
  width: 220px;
}

h2 {
  font-size: 20px;
  font-weight: 700;
  color: var(--color-text);
  margin: 0;
  letter-spacing: -0.01em;
}

.page-subtitle {
  color: var(--color-text-muted);
  font-size: 13px;
  margin-bottom: 4px;
}

/* Mobile Responsive Fix */
@media (max-width: 768px) {
  .filters-bar {
    flex-direction: column;
    align-items: stretch;
  }

  .filters-bar input[type="text"],
  .filters-bar select {
    width: 100%;
  }

  table, thead, tbody, th, td, tr {
    font-size: 12.5px;
  }
}

select,
input[type="file"] {
  padding: 8px;
  min-width: 160px;
  font-family: inherit;
}

/* ---------------------- Empty state ---------------------- */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 48px 20px;
  color: var(--color-text-muted);
  text-align: center;
}

.empty-state-icon {
  width: 44px;
  height: 44px;
  border-radius: 999px;
  background: var(--color-neutral-soft);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-text-faint);
  margin-bottom: 4px;
}

.empty-state-title {
  font-weight: 600;
  color: var(--color-text);
  font-size: 14px;
}

.empty-state-subtitle {
  font-size: 12.5px;
  color: var(--color-text-muted);
}

/* ---- App Shell / Topbar ---- */
.header-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  padding: 16px 22px;
  border-radius: var(--radius-lg);
  color: var(--color-text);
  margin-bottom: 20px;
  box-shadow: var(--shadow-xs);
}

.header-left h2 {
  margin: 0;
}

.header-left .header-breadcrumb {
  font-size: 12px;
  color: var(--color-text-faint);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 2px;
}

.header-center {
  flex: 1 1;
}

.user-email {
  font-size: 13.5px;
  margin: 0;
  color: var(--color-text-muted);
  font-weight: 500;
  text-align: right;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 14px;
}

.company-switcher {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--color-text-faint);
}

.company-switcher select {
  min-width: 0;
  max-width: 220px;
  padding: 6px 10px;
  font-size: 13px;
  border-radius: 8px;
  border: 1px solid var(--color-border);
  background: var(--color-surface);
  color: var(--color-text);
  cursor: pointer;
}

.user-chip {
  display: flex;
  align-items: center;
  gap: 10px;
}

.user-avatar {
  width: 34px;
  height: 34px;
  border-radius: 999px;
  background: var(--color-primary-soft);
  color: var(--color-primary-soft-text);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 13px;
  flex-shrink: 0;
}

.header-right .logout {
  padding: 8px 12px;
}

.top-scroll {
  overflow-x: auto;
  overflow-y: hidden;
  transform: rotateX(180deg);
}

.rotate-back {
  transform: rotateX(180deg);
}

/* ---------------------- Sidebar (grouped/accordion) ---------------------- */
.app-sidebar {
  background: var(--color-surface);
  border-right: 1px solid var(--color-border);
}

.sidebar-brand {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 4px 4px 18px;
  margin-bottom: 6px;
  border-bottom: 1px solid var(--color-border);
}

.sidebar-brand-mark {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  background: linear-gradient(135deg, var(--color-primary), #7c3aed);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 15px;
  flex-shrink: 0;
}

.sidebar-brand-text {
  font-weight: 800;
  font-size: 15.5px;
  color: var(--color-text);
  letter-spacing: -0.01em;
  line-height: 1.1;
}

.sidebar-brand-subtext {
  font-size: 11px;
  color: var(--color-text-faint);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.sidebar-scroll {
  scrollbar-width: thin;
}

.sidebar-scroll > * {
  flex-shrink: 0;
}

.sidebar-group {
  border-radius: var(--radius-sm);
  overflow: hidden;
}

.sidebar-group-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 10px;
  padding: 9px 10px;
  border-radius: var(--radius-sm);
  background: transparent;
  border: none;
  cursor: pointer;
  text-align: left;
  font-weight: 600;
  font-size: 13.5px;
  color: var(--color-neutral-text);
  transition: background 0.15s ease, color 0.15s ease;
}

.sidebar-group-header:hover {
  background: var(--color-neutral-soft);
  color: var(--color-text);
}

.sidebar-group-header.active {
  background: var(--color-primary-soft);
  color: var(--color-primary-soft-text);
}

.sidebar-group-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: var(--color-neutral-soft);
  color: var(--color-neutral-text);
  flex-shrink: 0;
}

.sidebar-group-header.active .sidebar-group-icon {
  background: rgba(79, 70, 229, 0.14);
  color: var(--color-primary);
}

.sidebar-group-items {
  display: flex;
  flex-direction: column;
  padding: 2px 0 6px 14px;
  gap: 1px;
  border-left: 2px solid var(--color-border);
  margin-left: 24px;
}

.sidebar-subitem {
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 7px 10px;
  border-radius: 7px;
  border: none;
  background: transparent;
  text-align: left;
  color: var(--color-text-muted);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}

.sidebar-subitem:hover {
  background: var(--color-neutral-soft);
  color: var(--color-text);
}

.sidebar-subitem.active {
  background: var(--color-primary);
  color: #fff;
  font-weight: 600;
  box-shadow: var(--shadow-xs);
}

/* ---------------------- KPI / stat cards ---------------------- */
.stat-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  margin-bottom: 20px;
}

.stat-card {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  padding: 18px 20px;
  box-shadow: var(--shadow-xs);
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.stat-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.stat-card-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.stat-card-label {
  font-size: 12.5px;
  font-weight: 600;
  color: var(--color-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.stat-card-value {
  font-size: 26px;
  font-weight: 800;
  color: var(--color-text);
  letter-spacing: -0.02em;
}

.content-card {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-xs);
  padding: 20px 22px;
}

/* ---------------------- Print (invoice) ---------------------- */
/* Rendered via a React portal straight into document.body (see InvoicePrintModal), so it sits
   outside the app's own DOM tree entirely — sibling to #root, not nested inside any modal/flex
   layout that print's static layout rules could otherwise mess with. */
.print-portal {
  display: none;
}

.invoice-print-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

.invoice-print-table th,
.invoice-print-table td {
  border: 1px solid #ccc;
  padding: 6px 8px;
  text-align: left;
}

.invoice-print-table thead th {
  background: #f1f2f6;
  font-weight: 700;
}

/* Page margins for the printed bill (see InvoicePrintModal): the sheet itself has none, so the
   browser has nowhere to print its own date / title / URL lines; the empty header and footer rows
   repeat on every sheet instead. */
.print-frame {
  width: 100%;
  border-collapse: collapse;
  background: transparent;
  border-radius: 0;
}

.print-frame > * > tr > td {
  padding: 0 12mm;
  border: 0;
  white-space: normal;
  overflow: visible;
  text-overflow: clip;
  max-width: none;
  font-size: inherit;
  color: inherit;
  background: transparent;
}

.print-frame > thead > tr > td,
.print-frame > tfoot > tr > td {
  height: 12mm;
  padding: 0;
}

@media print {
  @page {
    size: A4 portrait;
    margin: 0;
  }

  #root {
    display: none !important;
  }

  .print-portal {
    display: block;
    padding: 0;
  }

  /* a bill narrower than the page (e.g. Gold Winner) sits in the middle of it */
  .print-frame > tbody > tr > td > div > div {
    margin-left: auto;
    margin-right: auto;
  }

  /* a bill wider than A4 portrait is shrunk to the width of the page (InvoicePrintModal works the scale out) */
  .print-fit {
    zoom: var(--print-scale, 1);
  }

  .invoice-print-table {
    font-size: 11px;
  }
}

/* ---------------------- Compact layout (fewer scroll bars, more on screen) ---------------------- */
/* top bar: lower, less padding */
.header-bar {
  padding: 6px 14px;
  margin-bottom: 10px;
  min-height: 0;
}
.header-left h2 {
  font-size: 17px;
  line-height: 1.25;
}
.header-left .header-breadcrumb {
  font-size: 10.5px;
  margin-bottom: 0;
}
.header-right {
  gap: 10px;
}
.header-right .logout {
  padding: 5px 10px;
  font-size: 12.5px;
}

/* grids: tighter cells and wrapping headers so most tables fit the width without a horizontal scroll bar */
th, td {
  padding: 8px 10px;
  font-size: 13px;
}
thead th {
  white-space: normal;
  font-size: 11px;
  line-height: 1.25;
  vertical-align: bottom;
}
.table-wrapper {
  margin-top: 2px;
}

/* page area: 80% less padding than before around and inside each page (main 24 -> 5, panel 20/22 -> 4, page 16 -> 3) */
.header-bar {
  margin-bottom: 2px;
}
.page-panel {
  padding: 4px;
}
.page-panel > .p-4 {
  padding: 3px;
}

/* a table that must fit its width: fixed layout, cells wrap instead of widening the table */
table.fit-table {
  table-layout: fixed;
}
table.fit-table th,
table.fit-table td {
  white-space: normal;
  word-break: break-word;
  max-width: none;
  padding: 6px 6px;
  font-size: 12.5px;
}
table.fit-table td.action-buttons button {
  padding: 4px 8px;
  margin: 0 4px 4px 0;
}

/* popups: wider by default, so create / edit forms show 3 - 4 fields a row */
.modal-box {
  max-width: 1080px;
  width: 94vw;
  padding: 20px 24px;
}
.modal-box .form-grid {
  grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));
  gap: 12px 16px;
}
.modal-box.modal-xl {
  max-width: 1440px;
  width: 97vw;
}

/* the item grid of invoice forms fits the popup: fixed columns, compact boxes */
table.items-table.fit-items {
  table-layout: fixed;
}
table.items-table.fit-items th,
table.items-table.fit-items td {
  padding: 5px 4px;
  white-space: normal;
  max-width: none;
  overflow: visible;
}
table.items-table.fit-items input,
table.items-table.fit-items select {
  width: 100%;
  min-width: 0;
  padding: 5px 6px;
  font-size: 12.5px;
}
table.items-table.fit-items td.num,
table.items-table.fit-items th.num {
  text-align: right;
  font-variant-numeric: tabular-nums;
}
table.items-table.fit-items input.derived {
  background: #f3f4f7;
  color: var(--color-text-muted);
}

/* number boxes: no spin arrows (values are typed; the wheel no longer changes them) */
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type="number"] {
  -moz-appearance: textfield;
}

/* keyboard focus is always visible */
button:focus-visible,
[data-nav-field]:focus-visible {
  outline: 2px solid var(--color-primary);
  outline-offset: 1px;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;AAEd;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;;AAEnB,gEAAgE;AAChE;EACE,mBAAmB;EACnB,wBAAwB;EACxB,uBAAuB;EACvB,8BAA8B;EAC9B,qBAAqB;EACrB,2BAA2B;EAC3B,2BAA2B;;EAE3B,wBAAwB;EACxB,8BAA8B;EAC9B,6BAA6B;EAC7B,kCAAkC;;EAElC,wBAAwB;EACxB,6BAA6B;EAC7B,uBAAuB;EACvB,4BAA4B;EAC5B,wBAAwB;EACxB,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;;EAE7B,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;;EAEjB,6CAA6C;EAC7C,+EAA+E;EAC/E,8CAA8C;EAC9C,+CAA+C;AACjD;;AAEA,8DAA8D;AAC9D;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,+EAA+E;EAC/E,2BAA2B;EAC3B,wBAAwB;EACxB,mCAAmC;AACrC;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB;;;mBAGiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,+BAA+B;EAC/B,qCAAqC;EACrC,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,4CAA4C;EAC5C,+BAA+B;EAC/B,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,iFAAiF;AACnF;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,gCAAgC;EAChC,+CAA+C;AACjD;;AAEA,0DAA0D;AAC1D;EACE,oBAAoB;AACtB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,sCAAsC;EACtC,WAAW;EACX,sCAAsC;EACtC,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,8EAA8E;EAC9E,4BAA4B;AAC9B;;AAEA;;EAEE,4CAA4C;EAC5C,wCAAwC;AAC1C;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,sCAAsC;EACtC,wBAAwB;EACxB,4CAA4C;EAC5C,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0DAA0D;AAC5D;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,8BAA8B;EAC9B,4CAA4C;EAC5C,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,0CAA0C;EAC1C,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,sCAAsC;EACtC,0BAA0B;EAC1B,4CAA4C;EAC5C,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0DAA0D;AAC5D;;AAEA;EACE,0CAA0C;EAC1C,qBAAqB;AACvB;;AAEA,kEAAkE;AAClE;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,qCAAqC;EACrC,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,gCAAgC;EAChC,qCAAqC;EACrC,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,2CAA2C;EAC3C,sCAAsC;EACtC,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA,6DAA6D;AAC7D;EACE,gCAAgC;EAChC,qCAAqC;EACrC,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,yDAAyD;AACzD;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,4CAA4C;EAC5C,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,8BAA8B;EAC9B,UAAU;EACV,4CAA4C;AAC9C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,WAAW,2BAA2B,EAAE;AACxC,SAAS,0BAA0B,EAAE;;AAErC,gEAAgE;AAChE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,wBAAwB;AAC1B;AACA,cAAc,qCAAqC,EAAE,gCAAgC,EAAE;AACvF,cAAc,qCAAqC,EAAE,qCAAqC,EAAE;AAC5F,eAAe,qCAAqC,EAAE,2BAA2B,EAAE;AACnF,aAAa,oCAAoC,EAAE,0BAA0B,EAAE;AAC/E,eAAe,qCAAqC,EAAE,2BAA2B,EAAE;;AAEnF,6EAA6E;AAC7E;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kGAAkG;EAClG,eAAe;EACf,iBAAiB;AACnB;;AAEA,kHAAkH;AAClH;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,qCAAqC;EACrC,kCAAkC;EAClC,2CAA2C;AAC7C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,WAAW;AACb;;AAEA,iFAAiF;AACjF;;EAEE,gBAAgB;EAChB,QAAQ;EACR,UAAU;EACV,kDAAkD;AACpD;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,wDAAwD;AACxD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,+BAA+B;EAC/B,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,+BAA+B;EAC/B,4CAA4C;EAC5C,yBAAyB;EACzB,iFAAiF;AACnF;;AAEA;;EAEE,kCAAkC;EAClC,aAAa;EACb,gCAAgC;EAChC,+CAA+C;AACjD;;AAEA,2HAA2H;AAC3H;EACE,sBAAsB;AACxB;;AAEA;;EAEE,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,wBAAwB;EACxB,+BAA+B;EAC/B,yBAAyB;EACzB,sCAAsC;EACtC,0DAA0D;AAC5D;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,kCAAkC;EAClC,aAAa;EACb,+CAA+C;AACjD;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,kBAAkB;AACpB;;AAEA;;;EAGE,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,4CAA4C;EAC5C,+BAA+B;EAC/B,sCAAsC;EACtC,gBAAgB;EAChB,0DAA0D;AAC5D;;AAEA;;EAEE,aAAa;EACb,kCAAkC;EAClC,+CAA+C;AACjD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;EAChC,qCAAqC;EACrC,kBAAkB;EAClB,+BAA+B;EAC/B,wBAAwB;EACxB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,qCAAqC;EACrC,gCAAgC;EAChC,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,qCAAqC;EACrC,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,8EAA8E;AAC9E;EACE,gCAAgC;EAChC,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kEAAkE;EAClE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,SAAS;EACT,iBAAiB;EACjB,+BAA+B;EAC/B,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;EAChC,mDAAmD;AACrD;;AAEA;EACE,qCAAqC;EACrC,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,0CAA0C;EAC1C,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,qCAAqC;EACrC,wBAAwB;AAC1B;;AAEA;EACE,gCAAgC;EAChC,WAAW;EACX,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,+BAA+B;EAC/B,kBAAkB;EAClB,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;EAC9B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA,kEAAkE;AAClE;;uEAEuE;AACvE;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;mCAEmC;AACnC;EACE,WAAW;EACX,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,uBAAuB;AACzB;;AAEA;;EAEE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE;IACE,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,cAAc;IACd,UAAU;EACZ;;EAEA,8EAA8E;EAC9E;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA,6GAA6G;EAC7G;IACE,2BAA2B;EAC7B;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,qGAAqG;AACrG,iCAAiC;AACjC;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,2GAA2G;AAC3G;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB;;AAEA,uHAAuH;AACvH;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;;AAEA,4FAA4F;AAC5F;EACE,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,6EAA6E;AAC7E;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,4DAA4D;EAC5D,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA,gFAAgF;AAChF;EACE,mBAAmB;AACrB;AACA;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;AACA;;EAEE,iBAAiB;EACjB,kCAAkC;AACpC;AACA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA,sFAAsF;AACtF;;EAEE,wBAAwB;EACxB,SAAS;AACX;AACA;EACE,0BAA0B;AAC5B;;AAEA,qCAAqC;AACrC;;EAEE,uCAAuC;EACvC,mBAAmB;AACrB","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n/* ---------------------- Design tokens ---------------------- */\n:root {\n  --color-bg: #f4f5f9;\n  --color-surface: #ffffff;\n  --color-border: #e5e7eb;\n  --color-border-strong: #d7dae1;\n  --color-text: #14161f;\n  --color-text-muted: #6b7280;\n  --color-text-faint: #9ca3af;\n\n  --color-primary: #4f46e5;\n  --color-primary-hover: #4338ca;\n  --color-primary-soft: #eef2ff;\n  --color-primary-soft-text: #4338ca;\n\n  --color-success: #059669;\n  --color-success-soft: #ecfdf5;\n  --color-danger: #dc2626;\n  --color-danger-soft: #fef2f2;\n  --color-warning: #d97706;\n  --color-warning-soft: #fffbeb;\n  --color-neutral-soft: #f1f2f6;\n  --color-neutral-text: #4b5563;\n\n  --radius-sm: 8px;\n  --radius-md: 12px;\n  --radius-lg: 16px;\n\n  --shadow-xs: 0 1px 2px rgba(16, 24, 40, 0.05);\n  --shadow-sm: 0 1px 3px rgba(16, 24, 40, 0.08), 0 1px 2px rgba(16, 24, 40, 0.04);\n  --shadow-md: 0 8px 24px rgba(16, 24, 40, 0.08);\n  --shadow-lg: 0 24px 60px rgba(16, 24, 40, 0.18);\n}\n\n/* ---------------------- Base Styles ---------------------- */\n* {\n  box-sizing: border-box;\n}\n\nbody {\n  overflow-x: hidden;\n  margin: 0;\n  font-family: \"Inter\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\n  background: var(--color-bg);\n  color: var(--color-text);\n  -webkit-font-smoothing: antialiased;\n}\n\n/* ---------------------- Login Page ---------------------- */\n.login-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background:\n    radial-gradient(600px circle at 15% 20%, rgba(79, 70, 229, 0.10), transparent 60%),\n    radial-gradient(600px circle at 85% 80%, rgba(79, 70, 229, 0.08), transparent 60%),\n    var(--color-bg);\n}\n\n.login-form {\n  background: var(--color-surface);\n  padding: 40px 36px;\n  border-radius: var(--radius-lg);\n  border: 1px solid var(--color-border);\n  box-shadow: var(--shadow-md);\n  text-align: center;\n}\n\n.login-form h2 {\n  margin: 0 0 6px;\n  font-size: 22px;\n  font-weight: 800;\n  color: var(--color-text);\n  letter-spacing: -0.01em;\n}\n\n.login-form .login-subtitle {\n  color: var(--color-text-muted);\n  font-size: 13.5px;\n  margin-bottom: 24px;\n}\n\n.login-form input {\n  width: 100%;\n  padding: 12px 14px;\n  margin: 8px 0;\n  border: 1px solid var(--color-border-strong);\n  border-radius: var(--radius-sm);\n  font-size: 14px;\n  font-family: inherit;\n  background: #fbfbfd;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;\n}\n\n.login-form input:focus {\n  outline: none;\n  border-color: var(--color-primary);\n  background: var(--color-surface);\n  box-shadow: 0 0 0 3px var(--color-primary-soft);\n}\n\n/* ---------------------- Buttons ---------------------- */\nbutton {\n  font-family: inherit;\n}\n\nbutton.primary,\n.primary {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  background-color: var(--color-primary);\n  color: #fff;\n  border: 1px solid var(--color-primary);\n  padding: 9px 16px;\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 13.5px;\n  transition: background 0.15s ease, box-shadow 0.15s ease, transform 0.05s ease;\n  box-shadow: var(--shadow-xs);\n}\n\nbutton.primary:hover,\n.primary:hover {\n  background-color: var(--color-primary-hover);\n  border-color: var(--color-primary-hover);\n}\n\nbutton.primary:active,\n.primary:active {\n  transform: translateY(1px);\n}\n\nbutton.primary:disabled,\n.primary:disabled {\n  background-color: #c7c9f5;\n  border-color: #c7c9f5;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n.secondary {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: auto;\n  padding: 9px 16px;\n  background-color: var(--color-surface);\n  color: var(--color-text);\n  border: 1px solid var(--color-border-strong);\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 13.5px;\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n\n.secondary:hover {\n  background-color: #f9fafb;\n  border-color: #c6c9d2;\n}\n\n.secondary:disabled {\n  color: var(--color-text-faint);\n  cursor: not-allowed;\n}\n\nbutton.close-btn {\n  background-color: var(--color-surface);\n  color: var(--color-text-muted);\n  border: 1px solid var(--color-border-strong);\n  padding: 6px 14px;\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 13px;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\nbutton.close-btn:hover {\n  background-color: var(--color-danger-soft);\n  color: var(--color-danger);\n  border-color: #f3c6c6;\n}\n\n.logout {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background-color: var(--color-surface);\n  color: var(--color-danger);\n  border: 1px solid var(--color-border-strong);\n  padding: 8px 14px;\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 13.5px;\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n\n.logout:hover {\n  background-color: var(--color-danger-soft);\n  border-color: #f3c6c6;\n}\n\n/* ---------------------- Loading Spinner ---------------------- */\n.loading-overlay {\n  position: absolute;\n  inset: 0;\n  z-index: 50;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  background: rgba(244, 245, 249, 0.72);\n  backdrop-filter: blur(4px);\n  border-radius: var(--radius-lg);\n}\n\n.spinner-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  padding: 18px 24px;\n  border-radius: var(--radius-lg);\n  background: var(--color-surface);\n  border: 1px solid var(--color-border);\n  box-shadow: var(--shadow-md);\n  min-width: 180px;\n}\n\n.spinner-ring {\n  width: 36px;\n  height: 36px;\n  border-radius: 999px;\n  border: 3px solid var(--color-primary-soft);\n  border-top-color: var(--color-primary);\n  animation: spinner-rotate 0.8s linear infinite;\n}\n\n.spinner-ring-sm {\n  width: 16px;\n  height: 16px;\n  border-width: 2px;\n}\n\n.spinner-label {\n  font-size: 13.5px;\n  font-weight: 600;\n  color: var(--color-text);\n  text-align: center;\n}\n\n@keyframes spinner-rotate {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n/* ---------------------- Page shell ---------------------- */\n.page-panel {\n  background: var(--color-surface);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-xs);\n  padding: 20px 22px;\n  position: relative;\n}\n\n/* ---------------------- Tables ---------------------- */\n.table-wrapper {\n  overflow-x: auto;\n  border-radius: var(--radius-md);\n  border: 1px solid var(--color-border);\n  margin-top: 16px;\n}\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n  background-color: var(--color-surface);\n  border-radius: var(--radius-md);\n}\n\nth, td {\n  padding: 12px 16px;\n  text-align: left;\n  border: none;\n  border-bottom: 1px solid var(--color-border);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-size: 13.5px;\n  max-width: 240px;\n}\n\nthead th {\n  position: sticky;\n  top: 0;\n  background-color: #fafafc;\n  font-weight: 600;\n  font-size: 11.5px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--color-text-muted);\n  z-index: 1;\n  border-bottom: 1px solid var(--color-border);\n}\n\ntbody tr {\n  transition: background 0.1s ease;\n}\n\ntbody tr:last-child td {\n  border-bottom: none;\n}\n\ntbody tr:hover {\n  background-color: #fafafd;\n}\n\ntd {\n  color: var(--color-text);\n}\n\n.success { color: var(--color-success); }\n.error { color: var(--color-danger); }\n\n/* ---------------------- Status badges ---------------------- */\n.badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 3px 10px;\n  border-radius: 999px;\n  font-size: 11.5px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n  white-space: nowrap;\n}\n.badge::before {\n  content: \"\";\n  width: 6px;\n  height: 6px;\n  border-radius: 999px;\n  background: currentColor;\n}\n.badge-gray { background: var(--color-neutral-soft); color: var(--color-neutral-text); }\n.badge-blue { background: var(--color-primary-soft); color: var(--color-primary-soft-text); }\n.badge-green { background: var(--color-success-soft); color: var(--color-success); }\n.badge-red { background: var(--color-danger-soft); color: var(--color-danger); }\n.badge-amber { background: var(--color-warning-soft); color: var(--color-warning); }\n\n/* ---------------------- Dropdowns / toolbar inputs ---------------------- */\n.dropdowns {\n  margin: 10px 0 20px;\n}\n\n.action-buttons {\n  white-space: nowrap;\n  /* cells are capped at 240px with hidden overflow; a row of action buttons must never be clipped */\n  max-width: none;\n  overflow: visible;\n}\n\n/* td.flex would stop the cell behaving like a table cell, so the buttons are laid out inline with a gap instead */\ntd.action-buttons.flex {\n  display: table-cell;\n}\n\n.action-buttons button {\n  font-size: 12.5px;\n  padding: 7px 13px;\n  margin-right: 6px;\n  color: var(--color-primary-soft-text);\n  border-color: var(--color-primary);\n  background-color: var(--color-primary-soft);\n}\n\n.action-buttons button:last-child {\n  margin-right: 0;\n}\n\n.action-buttons button:hover {\n  background-color: var(--color-primary);\n  color: #fff;\n}\n\n/* Wide tables: keep the Actions column in view while the rest scrolls sideways */\nth.sticky-actions,\ntd.sticky-actions {\n  position: sticky;\n  right: 0;\n  z-index: 2;\n  box-shadow: -8px 0 8px -8px rgba(15, 17, 26, 0.18);\n}\n\ntd.sticky-actions {\n  background-color: var(--color-surface);\n}\n\ntbody tr:hover td.sticky-actions {\n  background-color: #fafafd;\n}\n\n/* ---------------------- Modal ---------------------- */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(15, 17, 26, 0.5);\n  backdrop-filter: blur(2px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 999;\n  padding: 20px;\n}\n\n.modal-box {\n  background: var(--color-surface);\n  padding: 28px 30px;\n  border-radius: var(--radius-lg);\n  width: 90%;\n  max-width: 760px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: var(--shadow-lg);\n  border: 1px solid var(--color-border);\n}\n\n.form-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 16px 20px;\n  margin-top: 16px;\n}\n\n@media (max-width: 600px) {\n  .form-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.form-group label {\n  font-size: 12.5px;\n  color: var(--color-text-muted);\n  font-weight: 600;\n  margin-bottom: 6px;\n}\n\n.form-group input,\n.form-group select {\n  padding: 9px 12px;\n  font-size: 13.5px;\n  font-family: inherit;\n  border-radius: var(--radius-sm);\n  border: 1px solid var(--color-border-strong);\n  background-color: #fbfbfd;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;\n}\n\n.form-group input:focus,\n.form-group select:focus {\n  border-color: var(--color-primary);\n  outline: none;\n  background: var(--color-surface);\n  box-shadow: 0 0 0 3px var(--color-primary-soft);\n}\n\n/* Item rows of the invoice / order forms: the boxes are typed into directly in the table, so they need a visible outline */\n.items-table td {\n  vertical-align: middle;\n}\n\n.items-table input:not([tabindex=\"-1\"]),\n.items-table select {\n  padding: 7px 10px;\n  min-width: 0;\n  font-size: 13.5px;\n  font-family: inherit;\n  color: var(--color-text);\n  border-radius: var(--radius-sm);\n  border: 1px solid #aab1bf;\n  background-color: var(--color-surface);\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.items-table select {\n  width: 100%;\n  min-width: 200px;\n}\n\n.items-table input:not([tabindex=\"-1\"]):focus,\n.items-table select:focus {\n  border-color: var(--color-primary);\n  outline: none;\n  box-shadow: 0 0 0 3px var(--color-primary-soft);\n}\n\n.items-table input::placeholder {\n  color: var(--color-text-faint);\n}\n\n.items-table button[type=\"button\"]:not(.close-btn) {\n  border-color: #aab1bf !important;\n}\n\n.field-error {\n  color: var(--color-danger);\n  font-size: 11px;\n  margin-top: 4px;\n}\n\n.modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 24px;\n  padding-top: 18px;\n  border-top: 1px solid var(--color-border);\n}\n\n/* Toolbar / filters */\n.filters-bar {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-bottom: 4px;\n}\n\n.filters-bar select,\n.filters-bar input[type=\"text\"],\n.filters-bar input[type=\"date\"] {\n  padding: 9px 12px;\n  font-size: 13.5px;\n  font-family: inherit;\n  border: 1px solid var(--color-border-strong);\n  border-radius: var(--radius-sm);\n  background-color: var(--color-surface);\n  min-width: 150px;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.filters-bar select:focus,\n.filters-bar input:focus {\n  outline: none;\n  border-color: var(--color-primary);\n  box-shadow: 0 0 0 3px var(--color-primary-soft);\n}\n\n.filters-bar input[type=\"text\"] {\n  width: 220px;\n}\n\nh2 {\n  font-size: 20px;\n  font-weight: 700;\n  color: var(--color-text);\n  margin: 0;\n  letter-spacing: -0.01em;\n}\n\n.page-subtitle {\n  color: var(--color-text-muted);\n  font-size: 13px;\n  margin-bottom: 4px;\n}\n\n/* Mobile Responsive Fix */\n@media (max-width: 768px) {\n  .filters-bar {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .filters-bar input[type=\"text\"],\n  .filters-bar select {\n    width: 100%;\n  }\n\n  table, thead, tbody, th, td, tr {\n    font-size: 12.5px;\n  }\n}\n\nselect,\ninput[type=\"file\"] {\n  padding: 8px;\n  min-width: 160px;\n  font-family: inherit;\n}\n\n/* ---------------------- Empty state ---------------------- */\n.empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 48px 20px;\n  color: var(--color-text-muted);\n  text-align: center;\n}\n\n.empty-state-icon {\n  width: 44px;\n  height: 44px;\n  border-radius: 999px;\n  background: var(--color-neutral-soft);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--color-text-faint);\n  margin-bottom: 4px;\n}\n\n.empty-state-title {\n  font-weight: 600;\n  color: var(--color-text);\n  font-size: 14px;\n}\n\n.empty-state-subtitle {\n  font-size: 12.5px;\n  color: var(--color-text-muted);\n}\n\n/* ---- App Shell / Topbar ---- */\n.header-bar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: var(--color-surface);\n  border: 1px solid var(--color-border);\n  padding: 16px 22px;\n  border-radius: var(--radius-lg);\n  color: var(--color-text);\n  margin-bottom: 20px;\n  box-shadow: var(--shadow-xs);\n}\n\n.header-left h2 {\n  margin: 0;\n}\n\n.header-left .header-breadcrumb {\n  font-size: 12px;\n  color: var(--color-text-faint);\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  margin-bottom: 2px;\n}\n\n.header-center {\n  flex: 1;\n}\n\n.user-email {\n  font-size: 13.5px;\n  margin: 0;\n  color: var(--color-text-muted);\n  font-weight: 500;\n  text-align: right;\n}\n\n.header-right {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n\n.company-switcher {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--color-text-faint);\n}\n\n.company-switcher select {\n  min-width: 0;\n  max-width: 220px;\n  padding: 6px 10px;\n  font-size: 13px;\n  border-radius: 8px;\n  border: 1px solid var(--color-border);\n  background: var(--color-surface);\n  color: var(--color-text);\n  cursor: pointer;\n}\n\n.user-chip {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.user-avatar {\n  width: 34px;\n  height: 34px;\n  border-radius: 999px;\n  background: var(--color-primary-soft);\n  color: var(--color-primary-soft-text);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  font-size: 13px;\n  flex-shrink: 0;\n}\n\n.header-right .logout {\n  padding: 8px 12px;\n}\n\n.top-scroll {\n  overflow-x: auto;\n  overflow-y: hidden;\n  transform: rotateX(180deg);\n}\n\n.rotate-back {\n  transform: rotateX(180deg);\n}\n\n/* ---------------------- Sidebar (grouped/accordion) ---------------------- */\n.app-sidebar {\n  background: var(--color-surface);\n  border-right: 1px solid var(--color-border);\n}\n\n.sidebar-brand {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 4px 4px 18px;\n  margin-bottom: 6px;\n  border-bottom: 1px solid var(--color-border);\n}\n\n.sidebar-brand-mark {\n  width: 34px;\n  height: 34px;\n  border-radius: 10px;\n  background: linear-gradient(135deg, var(--color-primary), #7c3aed);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 800;\n  font-size: 15px;\n  flex-shrink: 0;\n}\n\n.sidebar-brand-text {\n  font-weight: 800;\n  font-size: 15.5px;\n  color: var(--color-text);\n  letter-spacing: -0.01em;\n  line-height: 1.1;\n}\n\n.sidebar-brand-subtext {\n  font-size: 11px;\n  color: var(--color-text-faint);\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.sidebar-scroll {\n  scrollbar-width: thin;\n}\n\n.sidebar-scroll > * {\n  flex-shrink: 0;\n}\n\n.sidebar-group {\n  border-radius: var(--radius-sm);\n  overflow: hidden;\n}\n\n.sidebar-group-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  gap: 10px;\n  padding: 9px 10px;\n  border-radius: var(--radius-sm);\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  text-align: left;\n  font-weight: 600;\n  font-size: 13.5px;\n  color: var(--color-neutral-text);\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.sidebar-group-header:hover {\n  background: var(--color-neutral-soft);\n  color: var(--color-text);\n}\n\n.sidebar-group-header.active {\n  background: var(--color-primary-soft);\n  color: var(--color-primary-soft-text);\n}\n\n.sidebar-group-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  background: var(--color-neutral-soft);\n  color: var(--color-neutral-text);\n  flex-shrink: 0;\n}\n\n.sidebar-group-header.active .sidebar-group-icon {\n  background: rgba(79, 70, 229, 0.14);\n  color: var(--color-primary);\n}\n\n.sidebar-group-items {\n  display: flex;\n  flex-direction: column;\n  padding: 2px 0 6px 14px;\n  gap: 1px;\n  border-left: 2px solid var(--color-border);\n  margin-left: 24px;\n}\n\n.sidebar-subitem {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  padding: 7px 10px;\n  border-radius: 7px;\n  border: none;\n  background: transparent;\n  text-align: left;\n  color: var(--color-text-muted);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.sidebar-subitem:hover {\n  background: var(--color-neutral-soft);\n  color: var(--color-text);\n}\n\n.sidebar-subitem.active {\n  background: var(--color-primary);\n  color: #fff;\n  font-weight: 600;\n  box-shadow: var(--shadow-xs);\n}\n\n/* ---------------------- KPI / stat cards ---------------------- */\n.stat-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 16px;\n  margin-bottom: 20px;\n}\n\n.stat-card {\n  background: var(--color-surface);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-lg);\n  padding: 18px 20px;\n  box-shadow: var(--shadow-xs);\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.stat-card-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.stat-card-icon {\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.stat-card-label {\n  font-size: 12.5px;\n  font-weight: 600;\n  color: var(--color-text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.stat-card-value {\n  font-size: 26px;\n  font-weight: 800;\n  color: var(--color-text);\n  letter-spacing: -0.02em;\n}\n\n.content-card {\n  background: var(--color-surface);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-xs);\n  padding: 20px 22px;\n}\n\n/* ---------------------- Print (invoice) ---------------------- */\n/* Rendered via a React portal straight into document.body (see InvoicePrintModal), so it sits\n   outside the app's own DOM tree entirely — sibling to #root, not nested inside any modal/flex\n   layout that print's static layout rules could otherwise mess with. */\n.print-portal {\n  display: none;\n}\n\n.invoice-print-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 12px;\n}\n\n.invoice-print-table th,\n.invoice-print-table td {\n  border: 1px solid #ccc;\n  padding: 6px 8px;\n  text-align: left;\n}\n\n.invoice-print-table thead th {\n  background: #f1f2f6;\n  font-weight: 700;\n}\n\n/* Page margins for the printed bill (see InvoicePrintModal): the sheet itself has none, so the\n   browser has nowhere to print its own date / title / URL lines; the empty header and footer rows\n   repeat on every sheet instead. */\n.print-frame {\n  width: 100%;\n  border-collapse: collapse;\n  background: transparent;\n  border-radius: 0;\n}\n\n.print-frame > * > tr > td {\n  padding: 0 12mm;\n  border: 0;\n  white-space: normal;\n  overflow: visible;\n  text-overflow: clip;\n  max-width: none;\n  font-size: inherit;\n  color: inherit;\n  background: transparent;\n}\n\n.print-frame > thead > tr > td,\n.print-frame > tfoot > tr > td {\n  height: 12mm;\n  padding: 0;\n}\n\n@media print {\n  @page {\n    size: A4 portrait;\n    margin: 0;\n  }\n\n  #root {\n    display: none !important;\n  }\n\n  .print-portal {\n    display: block;\n    padding: 0;\n  }\n\n  /* a bill narrower than the page (e.g. Gold Winner) sits in the middle of it */\n  .print-frame > tbody > tr > td > div > div {\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  /* a bill wider than A4 portrait is shrunk to the width of the page (InvoicePrintModal works the scale out) */\n  .print-fit {\n    zoom: var(--print-scale, 1);\n  }\n\n  .invoice-print-table {\n    font-size: 11px;\n  }\n}\n\n/* ---------------------- Compact layout (fewer scroll bars, more on screen) ---------------------- */\n/* top bar: lower, less padding */\n.header-bar {\n  padding: 6px 14px;\n  margin-bottom: 10px;\n  min-height: 0;\n}\n.header-left h2 {\n  font-size: 17px;\n  line-height: 1.25;\n}\n.header-left .header-breadcrumb {\n  font-size: 10.5px;\n  margin-bottom: 0;\n}\n.header-right {\n  gap: 10px;\n}\n.header-right .logout {\n  padding: 5px 10px;\n  font-size: 12.5px;\n}\n\n/* grids: tighter cells and wrapping headers so most tables fit the width without a horizontal scroll bar */\nth, td {\n  padding: 8px 10px;\n  font-size: 13px;\n}\nthead th {\n  white-space: normal;\n  font-size: 11px;\n  line-height: 1.25;\n  vertical-align: bottom;\n}\n.table-wrapper {\n  margin-top: 2px;\n}\n\n/* page area: 80% less padding than before around and inside each page (main 24 -> 5, panel 20/22 -> 4, page 16 -> 3) */\n.header-bar {\n  margin-bottom: 2px;\n}\n.page-panel {\n  padding: 4px;\n}\n.page-panel > .p-4 {\n  padding: 3px;\n}\n\n/* a table that must fit its width: fixed layout, cells wrap instead of widening the table */\ntable.fit-table {\n  table-layout: fixed;\n}\ntable.fit-table th,\ntable.fit-table td {\n  white-space: normal;\n  word-break: break-word;\n  max-width: none;\n  padding: 6px 6px;\n  font-size: 12.5px;\n}\ntable.fit-table td.action-buttons button {\n  padding: 4px 8px;\n  margin: 0 4px 4px 0;\n}\n\n/* popups: wider by default, so create / edit forms show 3 - 4 fields a row */\n.modal-box {\n  max-width: 1080px;\n  width: 94vw;\n  padding: 20px 24px;\n}\n.modal-box .form-grid {\n  grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));\n  gap: 12px 16px;\n}\n.modal-box.modal-xl {\n  max-width: 1440px;\n  width: 97vw;\n}\n\n/* the item grid of invoice forms fits the popup: fixed columns, compact boxes */\ntable.items-table.fit-items {\n  table-layout: fixed;\n}\ntable.items-table.fit-items th,\ntable.items-table.fit-items td {\n  padding: 5px 4px;\n  white-space: normal;\n  max-width: none;\n  overflow: visible;\n}\ntable.items-table.fit-items input,\ntable.items-table.fit-items select {\n  width: 100%;\n  min-width: 0;\n  padding: 5px 6px;\n  font-size: 12.5px;\n}\ntable.items-table.fit-items td.num,\ntable.items-table.fit-items th.num {\n  text-align: right;\n  font-variant-numeric: tabular-nums;\n}\ntable.items-table.fit-items input.derived {\n  background: #f3f4f7;\n  color: var(--color-text-muted);\n}\n\n/* number boxes: no spin arrows (values are typed; the wheel no longer changes them) */\ninput[type=\"number\"]::-webkit-outer-spin-button,\ninput[type=\"number\"]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\ninput[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\n/* keyboard focus is always visible */\nbutton:focus-visible,\n[data-nav-field]:focus-visible {\n  outline: 2px solid var(--color-primary);\n  outline-offset: 1px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
